package or.app.orientalrecepies.network.models

import kotlinx.serialization.Serializable

@Serializable
data class Recipe(
    val id: String,
    val title: String,
    val description: String,
    val imageUrl: String,
    val category: String,
    val rating: Double,
    val prepTime: String,
    val level: String,
    val ingredients: List<Ingredient>,
    val instructions: List<Instruction>,
    val active: Boolean = true,
    val promoted: Boolean? = false
)

@Serializable
data class Ingredient(
    val name: String,
    val amount: String
)

@Serializable
data class Instruction(
    val step: Int,
    val description: String
)

@Serializable
data class Category(
    val id: String,
    val name: String
)

@Serializable
data class FavoriteRequest(
    val deviceId: String,
    val recipeId: String
)